import { type ReactNode } from 'react';
import './Panel.css';

interface PanelProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  tone?: 'default' | 'muted' | 'accent' | 'error';
  children: ReactNode;
  className?: string;
}

export function Panel({
  title,
  description,
  actions,
  tone = 'default',
  children,
  className,
}: PanelProps) {
  const cls = ['panel', `panel--${tone}`, className].filter(Boolean).join(' ');
  return (
    <section className={cls}>
      {(title || actions) && (
        <header className="panel__header">
          <div>
            {title && <h2 className="panel__title">{title}</h2>}
            {description && <p className="panel__desc">{description}</p>}
          </div>
          {actions && <div className="panel__actions">{actions}</div>}
        </header>
      )}
      <div className="panel__body">{children}</div>
    </section>
  );
}
